import $ from "jquery";

$(function () {
    const blocks = document.querySelectorAll('.aka-block-cards-news');

    blocks.forEach(block => {
        const container = block.querySelector('.js-cards-container');
        if (!container) return;

        const cards = container.querySelectorAll('.card-inner');
        const loadMoreBtn = block.querySelector('.js-load-more');
        const step = loadMoreBtn ? parseInt(loadMoreBtn.dataset.loadStep) : 8;
        let visibleCount = step;

        if (cards.length > step) {
            cards.forEach((card, index) => {
                if (index >= step) card.style.display = 'none';
            });
        } else if (loadMoreBtn) {
            loadMoreBtn.style.display = 'none';
        }

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', function () {
                console.log('Load More clicked');
                const hiddenCards = Array.from(cards).filter(c => c.style.display === 'none');
                hiddenCards.slice(0, step).forEach(c => c.style.display = '');
                visibleCount += step;

                if (visibleCount >= cards.length) {
                loadMoreBtn.style.display = 'none';
                }
            });
        }
    });
});

// 	let cardsSlider = document.querySelectorAll(".aka-block-cards-news .splide");
// 	if (cardsSlider.length > 0) {
// 		for (let i = 0; i < cardsSlider.length; i++) {
// 			let cardsElement = cardsSlider[i];
// 			let cardsDefaultOptions = {
// 				autoWidth: true,
// 				type: "loop",
// 				rewind: false,
// 				start: 0,
// 				arrows: true,
// 				perPage: 1,
// 				pagination: false,
// 				mediaQuery: "min",
// 				breakpoints: {
// 					1280: {
// 						destroy: true,
// 					},
// 				},
// 			};

// 			let cards = new Splide(cardsElement, cardsDefaultOptions);
// 			cards.mount();
// 		}
// 	}